import React from "react";
import ListingPage from "@/pages/ListingPage";

export default function LeasingPage() {
  return (
    <ListingPage
      listingType="leasing"
      title="Student accommodation across South Africa."
      subtitle="Handpicked residences from Johannesburg to Cape Town — secure, connected and ready to move into."
      heroImg="https://images.unsplash.com/photo-1522708323590-d24dbb6b0267?w=1920&auto=format&fit=crop&q=80"
    />
  );
}
